export default __webpack_public_path__ + "static/media/Make Something Powerful.41cc2870.png";